import { render, staticRenderFns } from "./ActBaseCustomModule.vue?vue&type=template&id=397be298&scoped=true&"
import script from "./ActBaseCustomModule.vue?vue&type=script&lang=js&"
export * from "./ActBaseCustomModule.vue?vue&type=script&lang=js&"
import style0 from "./ActBaseCustomModule.vue?vue&type=style&index=0&id=397be298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397be298",
  null
  
)

export default component.exports